import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=564e548b&scoped=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"
import style0 from "./contact.vue?vue&type=style&index=0&id=564e548b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e548b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextPressure: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/text-pressure.vue').default,AuroraBackground: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/aurora-background.vue').default})
